/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S6_Li1Inputs */

const tr_iade_iptal_s6_li1 = /** @type {(inputs: Iade_Iptal_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone hiçbir gerekçe göstermek ve bedel ödemek zorunda olmadan Aboneliği feshedebilir.`)
};

const en_iade_iptal_s6_li1 = /** @type {(inputs: Iade_Iptal_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Subscriber may terminate the Subscription without having to give any reason and without paying any fee.`)
};

const de_iade_iptal_s6_li1 = /** @type {(inputs: Iade_Iptal_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Abonnent kann das Abonnement ohne Angabe von Gründen und ohne Zahlung eines Entgelts beenden.`)
};

const ru_iade_iptal_s6_li1 = /** @type {(inputs: Iade_Iptal_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абонент вправе расторгнуть Подписку без указания причин и без уплаты вознаграждения.`)
};

/**
* | output |
* | --- |
* | "The Subscriber may terminate the Subscription without having to give any reason and without paying any fee." |
*
* @param {Iade_Iptal_S6_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s6_li1 = /** @type {((inputs?: Iade_Iptal_S6_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S6_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s6_li1(inputs)
	if (locale === "de") return de_iade_iptal_s6_li1(inputs)
	if (locale === "ru") return ru_iade_iptal_s6_li1(inputs)
	return tr_iade_iptal_s6_li1(inputs)
});